import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full relative lg:p-20 md:p-20 p-4"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-medium text-base md:text-lg lg:text-xl" }, " QRCode tidak support perangkat browser, dimohon untuk menggunakan aplikasi di smartphone ", -1)
const _hoisted_3 = {
  key: 1,
  class: "w-screen h-screen relative"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "absolute top-3 left-0 right-0 w-4/5 mx-auto bg-white py-4 rounded-lg" }, [
  /*#__PURE__*/_createVNode("h5", { class: "font-bold text-center" }, "Scan QRCODE"),
  /*#__PURE__*/_createVNode("p", { class: "text-center color-blue-grey text-sm" }, " Mohon untuk scan qrcode dengan jelas ")
], -1)
const _hoisted_5 = {
  key: 2,
  class: "w-screen h-screen flex items-center justify-center"
}
const _hoisted_6 = { class: "text-center w-4/5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-center mb-3 font-medium" }, "Pastikan kertas QRCODE jelas dan dapat dilihat!", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Scan Barcode ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (!_ctx.$store.state.device.isMobile)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _hoisted_2
      ]))
    : (_ctx.onScan == true)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Button, {
              class: "text-center btn-primary",
              onClick: _ctx.barcodeMobile
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
}